<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptyRegion')"
           :delete-row-function="(rows) => deleteRow('deleteRegions', rows)"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';
import Editor from './detail-row/RegionEditor';
import CommonBoardItems from '../CommonBoardItems';

Vue.component(config.detailRowComponentName, Editor);

export default {
  name: 'BoardRegion',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/region/BoardRegion.vue